var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plyr',{ref:"audio-plyr",staticClass:"is-block"},[_c('audio',[_c('source',{attrs:{"src":_vm.audio.url,"type":_vm.audio.mimeType}})])])}
var staticRenderFns = []

export { render, staticRenderFns }